import PropTypes from 'prop-types';
import Entity from '@/common-utils/components/renders/entity/Entity';
import isFalsy from '@/common-utils/functions/isFalsy';
import HISTORICS_VALUE_TYPE from '../../enums/HistoricsValueType';
import { Badge } from '@/common-utils/components/ui/badge';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import { nsHistorics } from '@/app/i18n/namespaces';
import RenderPermissionsHistorics from './RenderPermissionsHistorics';

/**
 *
 * @param {Object} props
 * @param {Object} props.cellData
 * @param {Object} props.action
 * @param {Object} props.cellDataBefore
 * @returns {JSX} RenderHistoricsValue
 */
const RenderHistoricsValue = ({ cellData, action, cellDataBefore = null }) => {

    // Constants
    const NO_VALUE_LABEL = <Entity entity='-' />;


    // Prevent null values from cellData
    if (isFalsy(cellData)) {
        return NO_VALUE_LABEL;
    }

    // FORMAT : {"UNKNOWN_TARGET_IDENTIFIER": VALUE(int, None) | {"users": None | LIST[str]}}
    if (cellData.UNKNOWNTargetIdentifier || cellData.UNKNOWNTargetIdentifier === 0) {
        const targetIdentifier = cellData.UNKNOWNTargetIdentifier;
        if (typeof targetIdentifier === 'object') {
            return targetIdentifier.users
                ? <Entity entity={targetIdentifier.users[0]} />
                : NO_VALUE_LABEL;
        }
        return <Entity entity={targetIdentifier.toString()} />;
    }

    const cellObject = Object.values(cellData)[0];
    if (Object.values(cellObject).length === 0) {
        return NO_VALUE_LABEL;
    }

    // FORMAT : {"UUID": {"KEY"(str): "VALUE"(str, int, list[str], None)}}
    const cellValue = Object.values(cellObject)[0];
    switch (action.type) {
        case HISTORICS_VALUE_TYPE.BADGE.name: {
            const badgeData = action.valuesList[cellValue];
            return <Badge entity={badgeData.entity} namespace={badgeData.namespace} variant={badgeData.variant} />;
        }
        case HISTORICS_VALUE_TYPE.DATE.name:
            return <RenderDateWithFromTime value={cellValue} />;
        case HISTORICS_VALUE_TYPE.LIST.name: {
            if (isFalsy(cellDataBefore)) {
                return NO_VALUE_LABEL;
            }
            const initialValue = cellDataBefore && Object.values(cellDataBefore)[0];
            return <RenderPermissionsHistorics
                initialPermissions={initialValue[action.dataKeys[0]]}
                finalPermissions={cellObject[action.dataKeys[0]]}
            />;
        }
        case HISTORICS_VALUE_TYPE.MULTI_VALUES.name: {
            if (isFalsy(cellDataBefore)) {
                return NO_VALUE_LABEL;
            }

            const initialValue = cellDataBefore && Object.values(cellDataBefore)[0];
            const modifications = { count: 0 };

            // From initial and final objects properties, counting the number of diffrent values
            if (initialValue && cellObject) {
                action.dataKeys.forEach((key) => {
                    if (initialValue[key] !== cellObject[key] && (!!initialValue[key] || !!cellObject[key])) {
                        modifications.count++;
                    }
                });
            }
            return <Entity entity='cells.modification_count' namespace={nsHistorics} data={modifications} className='italic' />;
        }
        default:
            return cellValue ? <Entity entity={cellValue} /> : NO_VALUE_LABEL;
    }
};

RenderHistoricsValue.propTypes = {
    cellData: PropTypes.object,
    action: PropTypes.object,
    cellDataBefore: PropTypes.object
};

export default RenderHistoricsValue;